import type { PiiLookupDocumentDto } from "@babackapp/private-api-client/generated/schema";
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from "@babackapp/ui/components/table";
import { format } from "date-fns";
import { useNavigate } from "react-router-dom";
import { PiiStatusCell } from "./pii-status-cell";

/** Return requests only: a row click opens the real return page. */
export function PiiReturnRequestsTable({
  shopId,
  documents,
}: {
  shopId: string;
  documents: PiiLookupDocumentDto[];
}) {
  const navigate = useNavigate();

  return (
    <div className="max-h-80 overflow-y-auto border rounded-md">
      <Table>
        <TableHeader className="sticky top-0 bg-background">
          <TableRow>
            <TableHead>Retour</TableHead>
            <TableHead>Créé le</TableHead>
            <TableHead>Statut</TableHead>
          </TableRow>
        </TableHeader>
        <TableBody>
          {documents.map((document) => (
            <TableRow
              key={document.id}
              className="cursor-pointer"
              onClick={() =>
                navigate(`/shops/${shopId}/returns/${document.id}`)
              }
            >
              <TableCell>{document.reference}</TableCell>
              <TableCell>
                {format(new Date(document.createdAt), "dd/MM/yyyy HH:mm")}
              </TableCell>
              <TableCell>
                <PiiStatusCell document={document} />
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </div>
  );
}
